import styled from 'styled-components';
import {
	ApButtonSecondary,
	ApInput,
	colors,
} from '@alixpartners/ui-components';

export const ActionsWrapper = styled.div`
	margin-top: -1px;
	height: 52px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	border: 1px solid ${colors.grey4};
	border-top: none;
	padding: 0 10px;

	${({ isActive }) => isActive && `border-color: ${colors.green2};`};
`;

export const Textarea = styled.textarea`
	width: 100%;
	height: 80px;
	resize: none;
	border: 1px solid ${colors.grey4};
	border-bottom: none;
	border-radius: 1px;
	background-color: transparent;
	color: ${colors.grey8};
	font-size: 16px;
	font-family: 'Roboto';
	line-height: 24px;
	appearance: none;
	z-index: 1;
	padding: 7px 10px;
	box-sizing: border-box;
	&:hover,
	&:focus {
		border-color: ${colors.green2};
		outline: none;
	}
	&:active {
		border-color: ${colors.green2};
		outline: none;
	}
`;

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	&:hover,
	&:focus {
		${ActionsWrapper}, ${Textarea} {
			border-color: ${colors.green2};
		}
	}
`;

export const StyledButton = styled(ApButtonSecondary)`
	position: absolute;
	right: 8px;
	bottom: 10px;
	z-index: 1;
`;

export const StyledInput = styled(ApInput)`
	input {
		font-family: 'Roboto';
	}
`;
